module.exports = __webpack_public_path__ + "img/examine.fec54f43.png";